/**
 * Created by portiz on 8/15/2018.
 */
import React from 'react';
import { Input, FormGroup, Col, Label, Alert } from 'reactstrap';
import Validator from '../../custom-classes/validator';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/

/**
 * Handle the class to a new password reset
 */
class FormGroupNewPassword extends React.Component{

    constructor(props){
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        this.state =
        {
            validPassword: true,
            password: '',
            passwordRetype: '',
        }; // Default value

        if(this.props.data)
        {
            this.state =
            {
                password: this.props.data.password,
                passwordRetype: this.props.data.passwordRetype,
                validPassword: true
            }; // Default value
        }

        this.handleChangePassword = this.handleChangePassword.bind(this);
        this.handleChangePasswordRetype = this.handleChangePasswordRetype.bind(this);
    }

    /**
     * If the props are not null, set the values
     * @param nextProps
     */
    componentWillReceiveProps(nextProps){

        if(typeof nextProps.data !== 'undefined'){
            this.setState({
                password: nextProps.data.password,
                passwordRetype: nextProps.data.passwordRetype,
            });
        }
    }

    /**
     * Action when the passwords are typed
     * @param event
     */
    handleChangePassword(event){
        this.setState({password: event.target.value}, () => {
                // Check if password are equals and show error if not
                this.setState({validPassword: Validator.isPasswordValid(this.state.passwordRetype, this.state.password)}, () =>
                {
                    this.props.updateParent(this.state);
                    return this.state;
                });
            }
        ); // This has a callback to evaluate the warning. If we don't use a callback, is not going to read the
        // last character while we are checking if they are equal or not
    }

    /**
     * Action when the password is retyped
     * @param event
     */
    handleChangePasswordRetype(event){
        this.setState({passwordRetype: event.target.value}, () => {
                // Check if password are equals and show error if not
                this.setState({validPassword: Validator.isPasswordValid(this.state.passwordRetype, this.state.password)}, () =>
                {
                    this.props.updateParent(this.state);
                    return this.state;
                });
            }
        ); // This has a callback to evaluate the warning. If we don't use a callback, is not going to read the
        // last character while we are checking if they are equal or not
    }

    // Render the form group
    render() {
        return (
            <div>
                <FormGroup row>
                    <Col sm={{ size: 10, offset: 1 }}>
                        <Label for="password">
                            <Translate id="register.password"/>
                        </Label>
                        <Input value={this.state.password} type="password" name="password" id="password" onChange={this.handleChangePassword} />
                    </Col>
                </FormGroup>
                <FormGroup row>
                    <Col sm={{ size: 10, offset: 1 }}>
                        <Label for="retype_password">
                            <Translate id="register.retype-password"/>
                        </Label>
                            <Input value={this.state.passwordRetype} type="password" name="retype_password" id="retype_password" onChange={this.handleChangePasswordRetype} />
                    </Col>
                </FormGroup>
                {
                    !this.state.validPassword ?
                    <FormGroup row>
                        <Col sm={{ size: 10, offset: 1 }}>
                            <Alert color="danger" isOpen={!this.state.validPassword}>
                                <Translate>{({translate}) => <span>{translate("register.password-error")}</span>}</Translate>
                            </Alert>
                        </Col>
                    </FormGroup> : null
                }
            </div>
        )
    };
}

export default FormGroupNewPassword;


// WEBPACK FOOTER //
// ./src/components/forms/form-group-new-password.js